export enum DateQueryTypeEnum {
    ABSOLUTE = 'ABSOLUTE',
    RELATIVE = 'RELATIVE',
    RELATIVE_TIMEZONE = 'RELATIVE_TIMEZONE',
    ALL = 'ALL' // used when date is null
}
